import React from 'react';
import { useWalletStore } from '../stores/walletStore';
import { CoinAmount } from './CoinAmount';

/**
 * Coin-cost hint next to an AI generate action. Renders nothing until the
 * action's price is marked ACTIVE in the admin console (ai_action_prices) —
 * flipping prices on there lights these up app-wide. During beta the cost is
 * informational only: AI is not charged yet.
 */
export function AiCostChip({ action, className = '' }: { action: string; className?: string }) {
  const priceCp = useWalletStore(
    (s) => s.aiPrices.find((p) => p.key === action)?.price_cp ?? null,
  );
  if (priceCp === null) return null;
  return (
    <span
      title="Coin cost — this action is charged to your wallet"
      className={`inline-flex items-center px-1.5 py-0.5 rounded-full border border-amber-400/30 bg-amber-400/10 text-[11px] font-semibold align-middle ${className}`}
    >
      <CoinAmount cp={priceCp} compact />
    </span>
  );
}
